export default defineNuxtPlugin({
    name: 'tracking',
    setup(nuxtApp) {
        if (useRuntimeConfig().public.googleTagManager.disabled) return;

        const router = useRouter();
        const { trackPageView } = useTracking();

        router.beforeEach(() => {
            const { clearStoryblokPageType } = useStoryblokTrackingPageType();
            clearStoryblokPageType();
        });

        router.afterEach(() => {
            const { trackLogState } = useTracking();
            trackLogState();
        });

        nuxtApp.hook('page:finish', () => {
            trackPageView();
        });
    },
});
